import { makeStyles } from '@material-ui/core/styles'
import { AvenirRegular, backgroundColor } from 'styles/variables'

export const useSummaryRowStyles = makeStyles({
  tableRow: {
    width: '100%',
    alignItems: 'center',
    backgroundColor: backgroundColor,
    border: 'solid 1px var(--border-input)',
    borderWidth: '1px 0 1px 0',
  },
  tableLoaderCell: {
    paddingTop: '20px',
    paddingBottom: '20px',
    scale: '0.7'
  },
  tableCell: {
  paddingTop: 10,
  paddingBottom: 10,
  fontFamily: AvenirRegular,
  fontSize: 15,
  minWidth: 110,
  whiteSpace: 'break-spaces',
  border: 'none'
},
  summaryRowTable: {
    left: 0,
    position: 'sticky',
  },
})
